import { useMemo } from 'react';
import { SurveyFormWrapper } from '../../../DigitalForms/form/components/SurveyFormWrapper';
import type { ClientForm } from '../../../DigitalForms/api/types/digitalForms.api.types';
import { useSubmitOnlineSchedulerDigitalForm } from '../../api/REST/useSubmitOnlineSchedulerDigitalForm';
import type { OnlineSchedulerDigitalForm } from '../../api/types/onlineSchedulerDigitalForm.api.types';

interface Props {
  form: OnlineSchedulerDigitalForm;
}

// Adapter that lets the OS digital form reuse the existing SurveyFormWrapper.
// The OS form lacks linked client/patient (request may not be linked yet) so
// those are passed as null. The HTML-template question type only consumes
// hospital fields, so the rendered survey is unaffected.
export const OnlineSchedulerSurveyFormWrapper = ({ form }: Props) => {
  const clientFormShim = useMemo<ClientForm>(
    () => ({
      id: form.id,
      statusId: form.statusId,
      createdAt: form.createdAt,
      createdByUserId: 0,
      digitalFormId: form.digitalFormId,
      clientName: form.clientName,
      internalNote: form.internalNote,
      patientId: form.patientId,
      clientId: form.clientId,
      hospitalId: form.hospitalId,
      email: form.email,
      phoneNumber: form.phoneNumber,
      uuid: form.uuid,
      surveyJson: form.surveyJson as ClientForm['surveyJson'],
      surveyThemeJson: form.surveyThemeJson,
      responseJson: null,
      completedAt: form.completedAt,
      species: form.species,
      backgroundThemeId: form.backgroundThemeId,
      formLayoutVersion: 2,
      patient: null,
      client: null,
    }),
    [form]
  );

  const submitMutation = useSubmitOnlineSchedulerDigitalForm({ opcode: 'osDfSb1bMt7nDsR2' });

  const submitOverride = useMemo(
    () => ({
      mutate: submitMutation.mutate,
      isPending: submitMutation.isPending,
    }),
    [submitMutation.mutate, submitMutation.isPending]
  );

  return <SurveyFormWrapper clientForm={clientFormShim} submitOverride={submitOverride} />;
};
